module.exports = __webpack_public_path__ + "static/fipcbrightteddy-074ccef1e73cc8e323005cac92326289.jpeg";